<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-list" v-if="resourceReadPermission">
		<div class="vx-card p-6 no-shadow">
			<div class="flex flex-wrap items-center" v-if="!customConfig.popupMode">
				<vs-input
					v-model="searchQuery"
					style="min-width: 17rem"
					class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
					:placeholder="$t('Search')"
					@input="updateSearchQuery"
				/>
				<vx-tooltip
					color="primary"
					position="bottom"
					:title="$t('Resource.AssigResources')"
					:text="$t('Resource.AssignResourceToltip')"
				>
					<vs-button
						class="ml-2 mr-2"
						color="success"
						type="filled"
						icon-pack="feather"
						icon="icon-user-plus"
						@click="resourceMounted = true"
						>{{ $t("Alarm.AddResources") }}
					</vs-button>
				</vx-tooltip>
				<vs-button
					v-if="relatedIds.length > 0"
					:title="$t('Schedule.Refresh')"
					class="ml-2 mr-2"
					color="primary"
					type="border"
					icon-pack="feather"
					icon="icon-refresh-cw"
					@click="refresh"
				></vs-button>
				<vx-tooltip
					v-if="resourcesData.length > 0"
					color="primary"
					position="bottom"
					:title="$t('Clear') + ' ' + $t('Table')"
				>
					<vs-button
						class="ml-2 mr-2"
						color="danger"
						type="border"
						icon-pack="feather"
						icon="icon-trash"
						@click.prevent="removeAllResources"
					></vs-button>
				</vx-tooltip>
			</div>
			<!-- AgGrid Table -->
			<ag-grid-vue
				ref="agGridTable"
				:components="components"
				:gridOptions="gridOptions"
				class="ag-theme-material w-100 my-4 ag-grid-table"
				:columnDefs="columnDefs"
				:defaultColDef="defaultColDef"
				:rowData="resourcesData"
				:rowSelection="customConfig.rowSelection"
				colResizeDefault="shift"
				:animateRows="true"
				:floatingFilter="true"
				:pagination="true"
				:paginationPageSize="paginationPageSize"
				:suppressPaginationPanel="true"
				:enableRtl="$vs.rtl"
				:overlayNoRowsTemplate="overlayNoRowsTemplate"
				@selection-changed="onSelectionChanged"
				@rowSelected="rowSelected"
				@grid-ready="onGridReady"
			>
			</ag-grid-vue>

			<vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
		</div>

		<!-- RESOURCES LIST COMPONENT -->
		<popup-customize :fullscreen="false" :title="null" :active="resourceMounted" :hidden-boolean="true">
			<resource-list
				v-if="resourceMounted"
				ref="ResourceList"
				:removeColumns="true"
				:customConfig="resourceListConfig"
				:componentParent="'ResourceListVisitPoint'"
				@showPopupEmmit="showPopup"
				@closePopup="closepopupEmit"
			/>
		</popup-customize>
	</div>
	<not-permission v-else></not-permission>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";

// Store Module
import moduleResource from "@/store/resource/moduleResource.js";
import moduleSchedule from "@/store/schedule/moduleSchedule.js";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";

// Components
import NotPermission from "@/views/pages/NotPermission.vue";
import ResourceList from "@/components/resource/user-list/ResourceList.vue";
import PopupCustomize from "../../../core/components/PopupCustomize";

export default {
	props: {
		removeColumns: {
			type: Boolean,
			default: () => false,
			required: false,
		},
		relatedIds: {
			type: Array,
			default: () => [],
		},
		customConfig: {
			type: Object,
			default: () => {
				return {
					rowSelection: "multiple",
					activeCheckbox: true,
					columns: [],
					actionDropdown: true,
					btnAssigResources: false,
					popupMode: false,
				};
			},
		},
	},
	components: {
		PopupCustomize,
		AgGridVue,
		vSelect,
		// Cell Renderer
		CellRendererLink,
		CellRendererStatus,
		CellRendererVerified,
		CellRendererActions,
		NotPermission,
		ResourceList,
	},
	data() {
		return {
			// Filter Options
			roleFilter: {label: "All", value: "all"},
			statusFilter: {label: "All", value: "all"},
			isVerifiedFilter: {label: "All", value: "all"},
			isVerifiedOptions: [
				{label: "All", value: "all"},
				{label: "Yes", value: "yes"},
				{label: "No", value: "no"},
			],
			departmentFilter: {label: "All", value: "all"},

			searchQuery: "",
			// AgGrid
			gridApi: null,
			gridOptions: {},
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
			},
			// Cell Renderer Components
			components: {
				CellRendererLink,
				CellRendererStatus,
				CellRendererVerified,
				CellRendererActions,
			},
			// columns config
			columnsConfigWidth: {
				email: this.removeColumns ? 350 : 225,
				lastname: this.removeColumns ? 200 : 150,
			},
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			//Config Resource List
			resourceListConfig: {
				rowSelection: "multiple",
				activeCheckbox: true,
				columns: ["id", "name", "lastname", "username", "email", "identification", "alias", "status"],
				actionDropdown: false,
				btnAssigResources: true,
				popupMode: true,
				assignedResourcesList: [],
				activeHeaderCheckboxSelection: true,
			},
			resourceMounted: false,
		};
	},
	watch: {
		roleFilter(obj) {
			this.setColumnFilter("role", obj.value);
		},
		statusFilter(obj) {
			this.setColumnFilter("status", obj.value);
		},
		isVerifiedFilter(obj) {
			const val = obj.value === "all" ? "all" : obj.value === "yes" ? "true" : "false";
			this.setColumnFilter("is_verified", val);
		},
		departmentFilter(obj) {
			this.setColumnFilter("department", obj.value);
		},
	},
	computed: {
		overlayNoRowsTemplate() {
			return `<span style="font-size: 16px; font-weight: 600; color: grey">${this.$t(
				"Resource.NotResources"
			)}</span>`;
		},
		// Colunms to render
		columnDefs() {
			let filterHead = this.customConfig.filterHead !== undefined ? this.customConfig.filterHead : true;
			// Columns
			let columns = [
				{
					headerName: "ID",
					field: "id",
					width: 125,
					filter: filterHead,
					checkboxSelection:
						this.customConfig.activeCheckbox !== undefined ? this.customConfig.activeCheckbox : true,
					headerCheckboxSelectionFilteredOnly: true,
					headerCheckboxSelection: this.customConfig.rowSelection === "multiple" ? true : false,
				},
				{
					headerName: this.$t("Username"),
					field: "username",
					filter: filterHead,
					width: 210,
					cellRendererFramework: this.removeColumns ? "" : "CellRendererLink",
				},
				{
					headerName: this.$t("Name"),
					field: "name",
					filter: filterHead,
					width: 200,
				},
				{
					headerName: this.$t("Lastname"),
					field: "lastname",
					filter: filterHead,
					width: this.columnsConfigWidth.lastname,
				},
				{
					headerName: this.$t("Email"),
					field: "email",
					filter: filterHead,
					width: this.columnsConfigWidth.email,
				},
				{
					headerName: this.$t("Role"),
					field: "alias",
					filter: filterHead,
					width: 150,
				},
				{
					headerName: this.$t("Status"),
					field: "status",
					filter: filterHead,
					width: 150,
					cellRendererFramework: "CellRendererStatus",
				},
				{
					headerName: this.$t("Type"),
					field: "typology_name",
					filter: filterHead,
					width: 150,
				},
				{
					headerName: this.$t("Groups.TotalGroups"),
					field: "total_group",
					filter: filterHead,
					width: 150,
				},
				{
					headerName: this.$t("Actions"),
					field: "transactions",
					width: 150,
					cellRendererFramework: "CellRendererActions",
					pinned: "right",
				},
			];

			// Filter table columns to show if showColumns is provided
			const showColumns =
				this.customConfig.columns !== undefined && this.customConfig.columns.length > 0
					? this.customConfig.columns
					: [];
			if (showColumns.length > 0) {
				columns = columns.filter((column) => {
					if (showColumns.includes(column.field)) {
						return column;
					}
				});
			}

			return columns;
		},
		resourcesData() {
			return this.$store.state.moduleResource.resourcesActivity;
		},
		paginationPageSize() {
			if (this.gridApi) return this.gridApi.paginationGetPageSize();
			else return 10;
		},
		totalPages() {
			if (this.gridApi) return this.gridApi.paginationGetTotalPages();
			else return 0;
		},
		currentPage: {
			get() {
				if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
				else return 1;
			},
			set(val) {
				this.gridApi.paginationGoToPage(val - 1);
			},
		},
		resourceReadPermission() {
			return this.$store.getters.checkPermission("RESOURCES_R");
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getResources() {
			const dataPage = {
				ids: this.relatedIds,
				order_by: "added_on",
				sort: "DESC",
				assig: true,
			};
			if (this.relatedIds.length <= 0) {
				return;
			}
			this.openLoading();
			this.$store
				.dispatch("moduleResource/fetchResourceFilter", dataPage)
				.then((res) => {
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
		setColumnFilter(column, val) {
			const filter = this.gridApi.getFilterInstance(column);
			let modelObj = null;

			if (val !== "all") {
				modelObj = {type: "equals", filter: val};
			}

			filter.setModel(modelObj);
			this.gridApi.onFilterChanged();
		},
		resetColFilters() {
			// Reset Grid Filter
			this.gridApi.setFilterModel(null);
			this.gridApi.onFilterChanged();
		},
		updateSearchQuery(val) {
			this.gridApi.setQuickFilter(val);
		},
		goToCreate() {
			this.$router.push(`/apps/resource/resource-create`);
		},
		getSelectedResources() {
			let selectedRows = this.gridApi.getSelectedRows();
			this.$emit("selectedResourcesEmit", selectedRows);
		},
		rowSelected(event) {
			this.$store.dispatch("moduleSchedule/selectedResource", event.data);
		},
		onSelectionChanged(event) {
			let rowCount = event.api.getSelectedNodes();
		},
		selectDataRowSelected() {
			this.gridApi.forEachNode((node) => {
				const valid = this.relatedIds.includes(node.data.id);
				node.setSelected(valid);
			});
		},
		onGridReady(params) {},
		refresh() {
			this.searchQuery = "";
			this.currentPage = 1;
			this.getResources();
		},
		showPopup(val) {
			this.resourceMounted = val;
		},
		closepopupEmit(val) {
			this.resourceMounted = val;
		},
		reset_data() {
			this.$store.dispatch("moduleResource/cleanResourceActivity");
		},
		removeAllResources() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("Resource.DeleteAllText"),
				accept: this.reset_data,
				acceptText: this.$t("Object.Yes"),
				cancelText: this.$t("Object.Not"),
			});
		},
	},
	mounted() {
		this.gridApi = this.gridOptions.api;
		/* =================================================================
          NOTE:
          Header is not aligned properly in RTL version of agGrid table.
          However, we given fix to this issue. If you want more robust solution please contact them at gitHub
        ================================================================= */
		if (this.$vs.rtl) {
			const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container");
			header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`;
		}
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}

		if (!moduleSchedule.isRegistered) {
			this.$store.registerModule("moduleSchedule", moduleSchedule);
			moduleSchedule.isRegistered = true;
		}
		this.getResources();
	},
	beforeDestroy() {
		this.$store.dispatch("moduleResource/cleanResourceActivity");
	},
};
</script>

<style lang="scss" scoped>
#page-user-list {
	.user-list-filters {
		.vs__actions {
			position: absolute;
			right: 0;
			top: 50%;
			transform: translateY(-58%);
		}
	}

	.radio-alignment {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		align-items: center;

		& > * {
			margin-right: 1.5rem;
			margin-top: 1.5rem;
		}
	}
}

.ag-grid-table {
	@media screen and (max-height: 800px) {
		height: 380px;
	}
}
</style>
